// Polyfills:
import "../../init";
// For some reason, React is required even tho not used? Wtf?
import React from "react";
import { createRoot } from "react-dom/client";
import AppWrapper from "../../components/AppWrapper";
import Root from "./Root";
const root = document.getElementById("root");
// We only want to try to render our component on pages that have a div with an ID
// of "example"; otherwise, we will see an error in our console
if (root) {
    createRoot(root).render(React.createElement(AppWrapper, null,
        React.createElement(Root, null)));
}
